import React, { useMemo } from 'react';
import { useEmbedTheme } from '../hooks/useEmbedTheme';
import { createAppTheme } from './createAppTheme';
import { readPrimaryPalette, readSurfacePalette } from './cssPalette';
import { applyThemeMode } from './embedTheme';
import { ThemeLayout } from './ThemeLayout';
import { AdminThemeContext } from './AdminThemeContext';

export const EmbedThemeLayout: React.FC = () => {
  const { mode, theme: colourTheme } = useEmbedTheme();

  const theme = useMemo(() => {
    applyThemeMode(mode);
    return createAppTheme({
      mode,
      primary: readPrimaryPalette(),
      surfaces: mode === 'dark' ? readSurfacePalette() : undefined,
    });
  }, [mode, colourTheme]);

  return (
    <AdminThemeContext.Provider value={theme}>
      <ThemeLayout theme={theme} mode={mode} />
    </AdminThemeContext.Provider>
  );
};
